import React from 'react';
import styled, { css } from 'styled-components';

import { useJacHomeData } from '@/modules/JacHome/hooks';
import { ContentContainer } from '@/modules/JacHome/common.styles';
import { AboutCardSecondary } from '@/components/LandingWidgets';
import { media } from '@/utils/mixin';

function TradeIn() {
  const { tradeInTitle, tradeInDescription, tradeInBenefits } =
    useJacHomeData();

  if (!tradeInBenefits || tradeInBenefits.length === 0) {
    return null;
  }

  return (
    <Component id="trade-in">
      <ContentContainer>
        <AboutCardSecondary
          id={6}
          title={tradeInTitle ?? ''}
          description={tradeInDescription ?? ''}
          benefits={tradeInBenefits.map(({ image, title, description }) => ({
            image,
            title: title ?? '',
            description: description ?? '',
          }))}
        />
      </ContentContainer>
    </Component>
  );
}

export default TradeIn;

const Component = styled.section`
  padding: 30px 0;

  ${media.tablet(css`
    padding: 20px 0;

    ${ContentContainer} {
      padding: 0 20px;
    }
  `)}
`;
